<template>
    <div>
        <div style="margin: 0 auto; ">
            <div class='header'>
                <img src="../assets/logo.png" class='logo' alt="春雪会计">
                <div class='cx-box'>
                    <van-grid clickable :column-num="2" :border='false'>
                        <van-grid-item icon="phone" text="电话咨询" url="tel:4008965569" />
                        <van-grid-item icon="service" text="在线咨询" url="http://chat.looyuoms.com/chat/chat/p.do?c=20002527&amp;f=10074818&amp;g=10070416&amp;refer=weixin" />
                        <van-grid-item icon="comment" text="最新通知" url="https://looyuoms7731.looyu.com/chat/chat/p.do?encrypt=1&c=20002527&f=10074818&g=10070416&refer=weixin&u=f3829aaa0cb3416680ab1886d66e0712&v=f3829aaa0cb3416680ab1886d66e0712&command=leaveMessage&_d=1565315280752" />
                        <van-grid-item icon="location" text="门店位置" url="/address" />
                    </van-grid>
                </div>
            </div>
            <div style='height:2em;'></div>
            <van-cell-group style='margin:0 auto;margin-top:2em;width:80%;'>
                <van-cell title="代理记账" value=">" size='large' url='http://m.chunxue.cn/dailijizhang.html' icon="service" />
                <van-cell title="工商服务" value=">" size='large' url='http://m.chunxue.cn/gongshangfuwu.html' icon="diamond" />
                <van-cell title="人力资源" value=">" size='large' url='http://m.chunxue.cn/renliziyuan.html' icon="manager" />
                <van-cell title="发展历程" value=">" size='large' url='/company' icon="fire" />
                <van-cell title="招聘信息" value=">" size='large' url='/recruit' icon="friends" />
            </van-cell-group>
        </div>
        <quick-menu style="bottom:75px" :menu-count=4 :background-color=backgroundColor :color=color :icon-class=icons :menu-url-list=list  :position=position></quick-menu>
    </div>
</template>
<script>
import quickMenu from "vue-quick-menu";
export default {
    components: { quickMenu },
    data() {
        return {
            icons: [
              'quick-menu-icon  fileIcon',
              'quick-menu-icon  historyIcon',
              'quick-menu-icon  paymentIcon',
              'quick-menu-icon  invoiceIcon',
              'quick-menu-icon  reportIcon',


            ],
            list: [
                { isLink: true, url: "/files",title:'上传票据'},
                { isLink: true, url: "/history" },
                { isLink: true, url: "/payment" },
                { isLink: true, url: "/invoice/list" },
                { isLink: true, url: "/financial-report/list" },
            ],
            backgroundColor: "#98c312",
            color: "#ffffff",
            position: "bottom-right",
            isOpenNewTab: false,
        };
    },
};
</script>
<style scoped>
.header {
    padding-top: 1em;
    background: -webkit-linear-gradient(
        #45972a 0%,
        #4ea022 20%,
        #5eb132 30%,
        #80ce56 40%,
        #9fe07d 50%,
        #c6efb2 60%,
        #fff 100%
    );
    text-align: center;
}

img {
    width: 100%;
    height: 100%;
}

.logo {
    width: 30%;
}

.cx-box {
    padding-top: 1em;
    padding-bottom: 5em;
    margin: 0 auto;
    margin-top: 1em;
    width: 92%;
    height: 100px;
    border-radius: 0.5em;
    background: #fff;
    box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.15);
}

</style>
<style >
.quick-menu-icon{
  display: inline-block;
  margin: 0 !important;
  text-align: center;
  width: 100%;
  height: 100%;
}
.quick-menu-icon::after{
    width: 100%;
    height: 100%;
    font-style: normal;
    font-size: 1.8rem;
    font-weight: 600;
    transform: scale(0.5);
    line-height: 2rem;
    display: block;

}
    .fileIcon::after{
    content: '上传票据';

}
.historyIcon::after{
    content: '历史上传';

}
.paymentIcon::after{
    content: '缴费信息';

}
.invoiceIcon::after{
    content: '发票管理';

}
.reportIcon::after{
    content: '财务报告';

}
</style>



// WEBPACK FOOTER //
// src/components/home.vue